var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.03906V15.2391C12 16.9192 12 17.7593 12.327 18.401C12.6146 18.9655 13.0735 19.4245 13.638 19.7121C14.2798 20.0391 15.1198 20.0391 16.8 20.0391H17M17 20.0391C17 21.1436 17.8954 22.0391 19 22.0391C20.1046 22.0391 21 21.1436 21 20.0391C21 18.9345 20.1046 18.0391 19 18.0391C17.8954 18.0391 17 18.9345 17 20.0391ZM7 4.03906L17 4.03906M7 4.03906C7 5.14363 6.10457 6.03906 5 6.03906C3.89543 6.03906 3 5.14363 3 4.03906C3 2.93449 3.89543 2.03906 5 2.03906C6.10457 2.03906 7 2.93449 7 4.03906ZM17 4.03906C17 5.14363 17.8954 6.03906 19 6.03906C20.1046 6.03906 21 5.14363 21 4.03906C21 2.93449 20.1046 2.03906 19 2.03906C17.8954 2.03906 17 2.93449 17 4.03906ZM12 12.0391H17M17 12.0391C17 13.1436 17.8954 14.0391 19 14.0391C20.1046 14.0391 21 13.1436 21 12.0391C21 10.9345 20.1046 10.0391 19 10.0391C17.8954 10.0391 17 10.9345 17 12.0391Z",
    stroke: "#B8C5CC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeview);
export default __webpack_public_path__ + "static/media/treeview.384decef0e6e477c2902782d9df2d43b.svg";
export { ForwardRef as ReactComponent };